import { createAction, props } from '@ngrx/store';
import { EntityKey } from '@feature/pma-entity/pma-entity-types';
import { BudgetVsActualConfigData } from '../models/budget-vs-actual-config-data.model';

const source = '[Budget Vs Actual Config Widget]';
const name = (actionName: string) => `${source} ${actionName}`;

export const BudgetConfigDataLoad = createAction(
  name('Load Budget Config Data'),
  props<{
    widgetConfigId: number;
  }>()
);

export const BudgetConfigDataLoadComplete = createAction(
  name('Load Budget Config Data Complete'),
  props<{
    widgetConfigId: number;
    data: BudgetVsActualConfigData;
  }>()
);

export const Clear = createAction(
  name('Clear Data'),
  props<{
    widgetConfigId: number;
  }>()
)
